import { Icon, type IconProps } from "./icon";

/** Domains: a micro seal, its rings broken at the seams between records. */
export function DomainsIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M17.22 9.37A7.25 7.25 0 0 1 10.63 17.22M6.94 16.57A7.25 7.25 0 0 1 3.43 6.94M5.84 4.06A7.25 7.25 0 0 1 15.94 5.84M10.74 14.19A4.25 4.25 0 0 1 6.74 7.27M9.26 5.81A4.25 4.25 0 0 1 13.26 12.73" />
      <circle cx="10" cy="10" r="1" fill="currentColor" stroke="none" />
    </Icon>
  );
}
